/**
 * One-time redeemable codes -> reward. Matched case-insensitively (see
 * SaveManager.hasRedeemedCode/markCodeRedeemed). Local-only, not
 * cloud-synced — logging out and back in, or clearing browser storage,
 * resets redemption state. Acceptable for a hobby game's freebie codes,
 * same trust model as the rest of this save data (see Currency.js's "no
 * anti-cheat" note on the leaderboard).
 */
export const REDEEM_CODES = {
  SURVIVOR777: { echoes: 1000, description: '+1000 Echoes' },
  SHARD999: { shards: 50, description: '+50 Sovereign Shards' },
  ALOY2026: { shards: 20, description: '+20 Sovereign Shards' },
  JIAMING: { description: 'If you read this, you are cool.' },
};
